<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="400">
    <v-card class="py-2">
      <v-card-title class="text-h5">
        <span class="ml-0">Vista previa</span>
        <v-spacer />
        <v-btn icon @click="$emit('update:dialog', false)">
          <v-icon small> fas fa-times </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <MessagePreview :message-template-selected="messageTemplateSelected" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import MessagePreview from "../components/MessagePreview";

export default {
  name: "WhatsAppModalPreview",
  components: { MessagePreview },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    messageTemplateSelected: {
      type: Object,
      required: true,
    },
  },
};
</script>
